import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-regis-person',
  templateUrl: './regis-person.component.html',
  styleUrls: ['./regis-person.component.scss']
})
export class RegisPersonComponent implements OnInit, OnDestroy {
  @Input()
  group: FormGroup;
  @Input()
  groupId: any;
  @Input()
  optionData: any;
  @Input()
  user: any;
  @Output()
  removed = new EventEmitter();
  fetching: { [key: string]: any } = {};
  // selectedType:FormControl
  type: any;
  constructor() {}
  ngOnInit() {
    this.onChanges();
    // console.log(this.group);
    if (this.user) {
      if (this.groupId === 0) {
        this.group.get('isMe').setValue(true);
      }

      if (this.group.value.entry) {
        const tmpEntry = [...this.optionData.types].find(t => t.id === this.group.value.entry.id);
        if (tmpEntry) {
          this.type = tmpEntry;
        }
        // console.log(tmpEntry);
      }
    }
  }

  selectedType(type) {
    // console.log(type);
    this.type = type;
    this.group.controls.entry.setValue({
      id: this.type.id,
      price: this.type.price,
      name: this.type.name,
      name_en: this.type.name_en
    });
    // this.group.controls.ageTypeId.setValue(this.type.id);
  }

  getDetailAgeType(min, max, gender) {
    if (min === 0 && max === 200) {
      return `รุ่นทัวไป ${this.getGenter(gender)}`;
    }
    if (min === 0 && max < 200) {
      return `รุ่นอายุไม่เกิน ${max} ปี  ${this.getGenter(gender)}`;
    }
    if (min > 0 && max === 200) {
      return `รุ่นอายุ ${min} ปีขึ้นไป  ${this.getGenter(gender)}`;
    }
    if (min > 0 && max < 200) {
      return `รุ่นอายุ ${min}-${max} ปี  ${this.getGenter(gender)}`;
    }
  }

  getGenter(gender) {
    if (gender === 'F') {
      return 'หญิง';
    } else if (gender === 'M') {
      return 'ชาย';
    } else {
      return '';
    }
  }

  optionnDisable(min, max, age) {
    if (age >= min && age <= max) {
      return false;
    }
    // if (min === 0 && max < 200) {
    //   return false
    // }
    // if (min > 0 && max === 200) {
    //   return false
    // }
    // if (min > 0 && max < 200) {
    //   return false
    // }
    return true;
  }

  onChanges() {
    this.fetching['getIsMe'] = this.group.get('isMe').valueChanges.subscribe(res => {
      if (res) {
        this.group.patchValue(this.user);
        this.group.get('name').setValue(this.user.displayName);
        // this.group.get('age').setValue(0);
      } else {
        this.group.patchValue({
          name: null,
          dateOfBirth: null,
          age: null,
          gender: null,
          bloodType: null,
          mobileNumber: null,
          idCard: null,
          passportNumber: null,
          nationality: null,
          email: null,
          lineId: null,
          team: null,
          emrContactName: null,
          emrContactPhoneNumber: null,
          emrContactAddress: null,
          ageTypes: null,
          shirtSize: null
        });
      }
    });

    this.fetching['getDateOfBirth'] = this.group.get('dateOfBirth').valueChanges.subscribe(res => {
      if (res) {
        // console.log(res);
        const today = new Date();
        const birthDate = new Date(res);
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        this.group.get('age').setValue(age);
      }
    });

    this.fetching['getType'] = this.group.get('entry').valueChanges.subscribe(res => {
      if (res) {
        // console.log(res);
        // this.group.controls.ageTypeId.setValue(null);
        this.checkAgeTypeByAge(this.group.get('age').value);
      }
    });

    this.fetching['ageTypeId'] = this.group.get('ageTypeId').valueChanges.subscribe(res => {
      // console.log(res);
      if (res !== null && res !== undefined) {
        const tmpAgeType = [...this.type.ageTypes].find(a => a.id === '' + res);
        if (tmpAgeType) {
          this.group.controls.ageType.setValue(tmpAgeType);
        }
      }
    });

    this.fetching['getAge'] = this.group.get('age').valueChanges.subscribe(res => {
      this.checkAgeTypeByAge(res);
    });

    this.fetching['getGender'] = this.group.get('gender').valueChanges.subscribe(res => {
      this.checkAgeTypeByAge(this.group.get('age').value);
    });
  }

  checkAgeTypeByAge(age) {
    if (this.type && this.type.ageTypes) {
      this.type.ageTypes.forEach(element => {
        if (this.checkAge(element.age_min, element.age_max, age)) {
          if (element.gender) {
            if (element.gender === this.group.controls.gender.value) {
              // console.log(element);
              this.group.controls.ageTypeId.setValue(element.id);
              this.group.controls.ageType.setValue(element);
            }
          } else {
            // console.log(element);
            this.group.controls.ageTypeId.setValue(element.id);
            this.group.controls.ageType.setValue(element);
          }
        }
      });
    }
  }

  checkAge(min, max, age) {
    if (age >= min && age <= max) {
      return true;
    }
    return false;
  }
  ngOnDestroy() {
    for (const key in this.fetching) {
      if (this.fetching.hasOwnProperty(key) && this.fetching[key]) {
        this.fetching[key].unsubscribe();
      }
    }
  }

  selectedAgeType(ageType) {
    console.log(ageType);
  }

  getForm() {
    console.log(this.group.value);
  }
}
